import { SummarizableReview } from 'lib/aiJobHelpers';
import AIJob from 'models/AIJob';
import JobProcess from 'models/JobProcess';
import ReviewModelFactory from 'models/reviews/ReviewModelFactory';
import { BaseMutationParams } from 'services/api/types';
import http from 'services/http';

export const aiJobQueryKeys = {
  base: ['aiJobs'],
  show: (id: string) => ['aiJobs', 'show', id],
};

type CreateAIJobInput = {
  type: string;
  reviewId?: string;
  aiCriteriaSetId?: string;
} & BaseMutationParams;

export const createAIJob = async (input: CreateAIJobInput) => {
  const { include, ...data } = input;
  return http.post<any>('/ai_jobs', data, { params: { include } }).then(
    (response) =>
      new AIJob({
        ...response.data,
        reviewId: response.data.reviewId || undefined,
      })
  );
};

export const createReviewSummaryJob = async (reviewId: string, reviewInclude: string): Promise<SummarizableReview> => {
  const response = await http.post<any>(
    '/ai_jobs',
    { type: 'summary', reviewId },
    { params: { include: reviewInclude } }
  );

  return ReviewModelFactory.get(response.data.review) as SummarizableReview;
};

export async function createAIJobExport(id: string) {
  return http.post<JobProcess>(`/ai_jobs/${id}/exports`).then((res) => new JobProcess(res.data));
}
